module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am179-5c721b5c75a0442a49b7d7bfd3b8df87.jpg";